import React, { Component } from 'react';
import ArrowButton from '../ui/ArrowButton';
import style from './ExhibitionSlider.module.scss';
import { pixiApp } from '../pixi/PixiApp';
import { navigateTo } from 'gatsby-link';
import ChapterCarousel from './ChapterCarousel';
import SwipeNextPrev from '../ui/SwipeNextPrev';
import AutoAdvancer from '../ui/AutoAdvancer';
import Helmet from 'react-helmet';
import { TweenLite } from 'gsap';
const textOutTime = 650;
const slideMoveTime = 1000;
const textInTime = 500;
import lillianMobile from '../../assets/lillian-wald-mobile.jpg';

class ExhibitionSlider extends Component {
  state = {
    currentSlide: 0,
    showText: !this.props.hidden,
    textExit: false,
    headerExit: false,
    hideUI: false,
    textTransitioning: false,
    hideTextWrap: false,
  };

  componentDidMount() {
    if (this.props.hidden) {
      TweenLite.set(this.wrapper, { display: 'none' });
    }
    const imageList = this.props.slides.map(chapter => {
      if (chapter.path.indexOf('problems-lead-to-action') !== -1) {
        if (window.innerWidth < 768) {
          return lillianMobile;
        }
      }
      const imageData1 =
        chapter.exhibition_sections[0].image.sizes &&
        chapter.exhibition_sections[0].image.sizes.large;
      if (imageData1) {
        return imageData1;
      } else {
        const imageData2 =
          chapter.exhibition_sections[0].images[0].sizes &&
          chapter.exhibition_sections[0].images[0].sizes.large;
        if (imageData2) {
          return imageData2;
        } else {
          console.warn("couldn't find exhibition slider image in ", chapter);
        }
      }
    });
    pixiApp.populateSlider(imageList);
    this.props.registerNextSlide(this.chapterNextSlide);
    this.props.registerNextSlideWithPixi(this.nextSlide);

    this.props.registerHideSliderText(this.hideTextWrap);
    // on mount, set pixi to visible or not
    pixiApp.sliderStartVisibility(this.props.hidden);
  }

  isExhibition(path) {
    return path === '/exhibition' || path === '/exhibition/';
  }
  componentWillReceiveProps(nextProps) {
    if (
      this.isExhibition(nextProps.location.pathname) &&
      !this.isExhibition(this.props.location.pathname)
    ) {
      this.setState({ hideUI: true });
      setTimeout(() => {
        this.setState({ hideUI: false });
      }, 300);
    }
  }
  lockBody() {
    const body = document.querySelector('body');
    body.style.height = window.innerHeight + 'px';
    body.style.overflow = 'hidden';
    window.addEventListener('resize', this.handleBody);
  }
  unlockBody() {
    const body = document.querySelector('body');
    body.style.height = '100%';
    body.style.overflow = 'auto';
    window.removeEventListener('resize', this.handleBody);
  }
  handleBody = () => {
    const body = document.querySelector('body');
    body.style.height = window.innerHeight + 'px';
  };
  componentDidUpdate(prevProps) {
    if (
      this.isExhibition(this.props.location.pathname) &&
      !this.isExhibition(prevProps.location.pathname)
    ) {
      this.lockBody();
      this.setHeaderStyle();
      // if (pixiApp.isStopped) {
      pixiApp.showSlider();
      // }
      // if going from chapter to exhibition, force slider visible
      if (prevProps.location.pathname.indexOf('exhibition') !== -1) {
        pixiApp.setSliderVisible();
      }
    }

    if (
      !this.isExhibition(this.props.location.pathname) &&
      this.isExhibition(prevProps.location.pathname)
    ) {
      this.unlockBody();
    }

    // show and hide pixi slider
    if (
      prevProps.exhibitionRouteStatus !== 'exiting' &&
      this.props.exhibitionRouteStatus === 'exiting'
    ) {
      this.fadeOff();
    }

    if (!prevProps.hidden && this.props.hidden) {
      this.fadeOff();
      pixiApp.hideSlider();
      this.setState({ showText: false, textExit: false });
    } else if (prevProps.hidden && !this.props.hidden) {
      this.fadeOn();
      // if going from hidden to shown, reset state
      this.setState(
        {
          currentSlide: 0,
          textExit: false,
          showText: false,
        },
        () => {
          pixiApp.skipSliderTo(0);
          this.props.setThemeColor(this.getColorByIndex(0));
          pixiApp.fadeOnSlider();
          this.setHeaderStyle();
          setTimeout(() => {
            this.setState({
              showText: true,
            });
          }, 300);
        }
      );
    }
  }
  fadeOn() {
    TweenLite.set(this.wrapper, { opacity: 0 });
    this.wrapper.style.display = 'block';
    TweenLite.to(this.wrapper, 0.75, {
      opacity: 1,
    });
  }
  fadeOff() {
    pixiApp.fadeOutSlider();
    TweenLite.to(this.wrapper, 0.5, {
      opacity: 0,
      onComplete: () => {
        this.wrapper.style.display = 'none';
      },
    });
  }

  setHeaderStyle() {
    this.props.setMainMenuColor('black');
    this.props.setLogoColor('black');
    this.props.setHeaderGradient(false);
    this.props.setThemeColor(
      this.props.slides[this.state.currentSlide].color_theme
    );
  }

  handleChapterClick = e => {
    e.preventDefault();
    if (this.pause) {
      this.pause();
    }
    const currentChapter = this.props.slides[this.state.currentSlide];
    const nextPath = currentChapter.path;

    // subtext out
    this.setState({ textExit: true });

    // header transition after delay
    setTimeout(() => {
      this.props.setHeaderStyleFromSection({ section_type: 'default' });
      this.setState({ hideUI: true });
    }, 500);

    // start pixi chapter open
    pixiApp.openCurrentChapter(callback => {
      setTimeout(() => {
        this.setState({ headerExit: true });
      }, 200);

      // then navigate, reveals chapter text
      setTimeout(() => {
        navigateTo(nextPath);
        setTimeout(() => {
          this.props.setHeaderStyleFromSection(
            this.props.slides[this.state.currentSlide].exhibition_sections[0]
          );
        }, 400);

        if (callback) {
          setTimeout(callback, 2000);
        }
      }, 600);

      setTimeout(() => {
        // reset text styles when complete
        this.setState({
          showText: true,
          textExit: false,
          headerExit: false,
          hideUI: false,
        });
        pixiApp.hideSlider();
      }, 4000);
    });
  };
  hideTextWrap = () => {
    this.setState({ hideTextWrap: true });
  };
  showTextWrap = () => {
    this.setState({ hideTextWrap: false });
  };
  showText = () => {
    this.setState({ showText: true });
  };

  hideText = () => {
    this.setState({ showText: false });
  };

  handleSlideTransition(handler) {
    this.isTransitioning = true;
    this.hideText();
    this.setState({
      textTransitioning: true,
    });
    setTimeout(() => {
      if (this.state.hideTextWrap) {
        this.setState({ hideTextWrap: false });
      }
      this.showText();
    }, textOutTime + slideMoveTime);
    setTimeout(() => {
      this.setState({
        textTransitioning: false,
      });
      this.isTransitioning = false;
    }, textOutTime + slideMoveTime + textInTime);
  }

  // just handles text, not pixi images
  chapterNextSlide = (index, doPixi) => {
    // TODO: make this smarter than a timeout
    setTimeout(() => {
      this.handleSlideTransition();
      let nextIndex = 0;
      if (typeof index !== undefined) {
        nextIndex = index;
      } else if (this.state.currentSlide < this.props.slides.length - 1) {
        nextIndex = this.state.currentSlide + 1;
      }
      setTimeout(() => {
        this.props.setThemeColor(this.getColorByIndex(nextIndex));
        this.setState({ currentSlide: nextIndex });
      }, textOutTime);
    }, 1000);
  };

  nextSlide = index => {
    if (this.isTransitioning) {
      return;
    }
    let nextIndex;
    if (typeof index === 'undefined') {
      if (this.state.currentSlide < this.props.slides.length - 1) {
        nextIndex = this.state.currentSlide + 1;
      } else {
        return;
      }
    } else {
      nextIndex = index;
    }
    this.handleSlideTransition();
    pixiApp.sliderTo(nextIndex);
    setTimeout(() => {
      this.props.setThemeColor(this.getColorByIndex(nextIndex));
      this.setState({ currentSlide: nextIndex });
    }, textOutTime);
  };

  prevSlide = () => {
    if (!this.isTransitioning && this.state.currentSlide > 0) {
      const nextIndex = this.state.currentSlide - 1;
      this.handleSlideTransition();
      pixiApp.sliderTo(nextIndex);
      setTimeout(() => {
        this.props.setThemeColor(this.getColorByIndex(nextIndex));
        this.setState({ currentSlide: nextIndex });
      }, textOutTime);
    }
  };

  getColorByIndex(index) {
    return this.props.slides[index].color_theme;
  }
  registerPause = func => {
    this.pause = func;
  };

  render() {
    const currentChapter = this.props.slides[this.state.currentSlide];
    const rightInactive =
      this.state.currentSlide === this.props.slides.length - 1;
    const leftInactive = this.state.currentSlide === 0;

    return (
      <div
        className={style.exhibitionWrapper}
        ref={el => {
          this.wrapper = el;
        }}
      >
        {this.isExhibition(this.props.location.pathname) && (
          <Helmet title={`Exhibition | The House on Henry Street`} />
        )}
        {this.isExhibition(this.props.location.pathname) && (
          <SwipeNextPrev next={this.nextSlide} prev={this.prevSlide} />
        )}
        <div
          className={`${style.leftButton} ${
            this.state.hideUI ? style.hidden : ''
          }`}
        >
          <ArrowButton
            direction={'left'}
            onClick={() => {
              this.prevSlide();
            }}
            inactive={this.state.currentSlide === 0}
          />
          <p
            className={`${style.leftLabel} ${
              leftInactive ? style.inactiveLabel : ''
            }`}
          >
            previous<br />chapter
          </p>
        </div>
        <div
          className={`${style.rightButton} ${
            this.state.hideUI ? style.hidden : ''
          }`}
        >
          <ArrowButton
            direction={'right'}
            onClick={() => {
              this.nextSlide();
            }}
            inactive={rightInactive}
          />
          <p
            className={`${style.rightLabel} ${
              rightInactive ? style.inactiveLabel : ''
            }`}
          >
            next<br />chapter
          </p>
        </div>

        <ChapterCarousel
          {...currentChapter}
          index={this.state.currentSlide}
          // registerExploreButton={this.registerExploreButton}
          show={this.state.showText}
          textExit={this.state.textExit}
          headerExit={this.state.headerExit}
          handleChapterClick={this.handleChapterClick}
          textTransitioning={this.state.textTransitioning}
          hideTextWrap={this.state.hideTextWrap}
        />

        {/* We can render a pagination component that takes this.state.currentSlide as a prop */}
        {this.isExhibition(this.props.location.pathname) && (
          <AutoAdvancer
            colorTheme={this.getColorByIndex(this.state.currentSlide)}
            waitingForLoad={this.props.introIsShowing}
            isTransitioning={this.state.textTransitioning}
            nextSlide={this.nextSlide}
            anySlide={this.nextSlide}
            totalSlides={this.props.slides.length}
            currentIndex={this.state.currentSlide}
            registerPause={this.registerPause}
            exited={this.state.hideUI}
          />
        )}
      </div>
    );
  }
}

export default ExhibitionSlider;



// WEBPACK FOOTER //
// ./src/components/exhibition/ExhibitionSlider.js